import local from "./local.js";
import session from "./session.js";


export default {
    local,
    session,
};
